import styled from 'styled-components';
import { withTheme } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

const CaptionTypography = styled(Typography)`
  border-left: 4px solid ${props => props.theme.palette.divider};
  padding-left: 20px;
  display: inline-block;
  text-align: left;
`;

export default withTheme()(CaptionTypography);
